import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param grnId
 * @param poId
 */
class GRNServices {
  /**
   *
   * @param {*} payload
   * @return
   */
  createGRN = async (payload) => {
    const grn = await Helpers.post({
      url: Constants.GRN,
      data: payload,
    });
    return grn;
  }

  /**
* @param {*} fileType - The type of the file.
* @param {*} orgId - The ID of the organization.
* @param {*} tenantId - The ID of the tenant.
* @param {*} grnId - The ID of the GRN .
* @param {*} grnEntityId - The ID of the GRN entity.
* @param {*} grnEntityType - The type of the GRN entity.
* @param {*} status - The status of the entity.
* @param {*} limit - The maximum number of results to return per page.
* @param {*} page - The page number.
* @param {*} tenantSellerId - The ID of the tenant seller.
* @param {*} selectedEntityType - The selected entity type.
* @param {*} searchKeyword - The keyword used for searching.
* @param {*} columns - An string of columns to include in the result.
*
* @returns {file} - The downloaded PDF of GRN Table
*/
  downloadGRNData = async (payload) => {
    const grnData = await Helpers.post({
      url: Constants.GRN_DOWNLOAD_DATA,
      data: payload,
    });
    return grnData;
  }

  /**
     *
     * @param {*} payload
     * @return
     */
  updateGRN = async (payload) => {
    const grn = await Helpers.put({
      url: Constants.GRN,
      data: payload,
    });
    return grn;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateGRNStatus = async (payload) => {
    const po = await Helpers.post({
      url: Constants.GRN_STATUS,
      data: payload,
    });
    return po;
  }

  /**
   * @return
   * @param poId
   * @param page
   * @param grnId
   * @param tenantId
   * @param grnEntityId
   * @param gsrEntityType
   * @param status
   * @param limit
   * @param grnEntityType
   * @param tenantSellerId
   * @param sellerId
   * @param selectedEntityType
   * @param searchKeyword
   * @param po_id
   */
  getGRN = async (tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn,excludeGRNIds,excludeGRNVendorIds, is_list, billingStatus) => {
    let url = `${Constants.GRN}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (grnId) url += `grn_id=${grnId}&`;
    if (grnEntityId) url += `grn_entity_id=${grnEntityId}&`;
    if (grnEntityType) url += `grn_entity_type=${grnEntityType}&`;
    if (status) url += `status=${status}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (tenantSellerId) url += `tenant_seller_id=${tenantSellerId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (excludeGRNVendorIds) url += `seller_ids=${excludeGRNVendorIds}&`;
    if (selectedEntityType) url += `grn_entity_type=${selectedEntityType}&`;
    if (startDate) url += `from_grn_date_time=${startDate}&`;
    if (endDate) url += `to_grn_date_time=${endDate}&`;
    if (grnFromDueDate) url += `from_grn_due_date=${grnFromDueDate}&`;
    if (grnToDueDate) url += `to_grn_due_date=${grnToDueDate}&`;
    if (scheduleGrn) url += `schedule_grn=${scheduleGrn}&`;
    if (paymentStatus) url += `payment_status=${paymentStatus}&`;
    if (sourceOfGrn) url += `grn_entity_type=${sourceOfGrn}&`;
    if (tags) url += `tags=${tags}&`;
    if (departmentIds) url += `department_ids=${departmentIds}&`;
    if (excludeGRNIds) url += `exclude_grn_ids=${excludeGRNIds}&`;
    if (is_list) url += `is_list=${true}&`;
    if (billingStatus) url += `billing_status=${billingStatus}&`;
    url += 'map_grn_payments=true';
    const grn = await Helpers.get({ url });
    return grn;
  }

  /**
   *
   * @param tenantId
   * @param grnId
   * @return {Promise<*>}
   */
  deleteGrn = async (tenantId, grnId) => {
    const deletedGrn = await Helpers.delete({
      url: Constants.GRN,
      data: {
        tenant_id: tenantId,
        grn_id: grnId,
      },
    });
    return deletedGrn;
  }

  updateGRNWorkflowStep = async (payload) => {
    const updateGRNWorkflowStep = await Helpers.post({
      url: `${Constants.GRN}/workflow`,
      data: payload,
    });
    return updateGRNWorkflowStep;
  }

  quickUpdateGRN = async (payload) => {
    const invoice = await Helpers.put({
      url: Constants.GRN_QUICK_UPDATE,
      data: payload,
    });
    return invoice;
  }

  sendGRNMailToVendor = async (payload) => {
    const url = `${Constants.GRN}/send_mail`;
    const vendorMail = await Helpers.post({
      url,
      data: payload,
    });
    return vendorMail;
  }
}
export default new GRNServices();
